import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (path, body) => {
    const { data } = await api.post(path, body);
    if (data.otp_required) return data;
    if (data.device_token) localStorage.setItem("ccm_device", data.device_token);
    localStorage.setItem("ccm_token", data.token);
    setUser(data.user);
    return data;
  };

  const setSession = (data) => {
    localStorage.setItem("ccm_token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ccm_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout, setSession }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
